export const fonts = [
    'Arial',
    'Times New Roman',
    'Courier New',
    'Georgia',
    'Verdana',
    'Helvetica',
    'Calibri',
    'Tahoma',
    'Trebuchet MS',
    'Impact',
    'Comic Sans MS',
    'Arial Black',
    'Palatino',
    'Garamond',
    'Bookman',
    'Avant Garde',
    'Lucida Grande',
    'Century Gothic',
    'Copperplate',
    'Baskerville'
];

export const fontSizes = [
    '8',
    '9',
    '10',
    '11',
    '12',
    '14',
    '16',
    '18',
    '20',
    '22',
    '24',
    '26',
    '28',
    '32',
    '36',
    '40',
    '48',
    '56',
    '64',
    '72'
];

export const colors = [
    // Basic Colors
    '#000000', // Black
    '#FFFFFF', // White
    '#808080', // Gray
    '#C0C0C0', // Silver
    '#800000', // Maroon
    '#FF0000', // Red
    '#808000', // Olive
    '#FFFF00', // Yellow
    '#000080', // Navy
    '#0000FF', // Blue
    '#008080', // Teal
    '#00FFFF', // Aqua
    '#008000', // Green
    '#00FF00', // Lime
    '#800080', // Purple
    '#FF00FF', // Fuchsia

    // Additional Shades
    '#FFA500', // Orange
    '#FFD700', // Gold
    '#4B0082', // Indigo
    '#EE82EE', // Violet
    '#FFC0CB', // Pink
    '#A52A2A', // Brown
    '#DEB887', // BurlyWood
    '#5F9EA0', // CadetBlue
    '#7FFF00', // Chartreuse
    '#D2691E', // Chocolate
    '#6495ED', // CornflowerBlue
    '#DC143C', // Crimson
    '#00008B', // DarkBlue
    '#008B8B', // DarkCyan
    '#B8860B', // DarkGoldenRod
    '#A9A9A9', // DarkGray
    '#006400', // DarkGreen
    '#BDB76B', // DarkKhaki
    '#8B008B', // DarkMagenta
    '#556B2F', // DarkOliveGreen
    '#FF8C00', // DarkOrange
    '#9932CC', // DarkOrchid
    '#8B0000', // DarkRed
    '#E9967A', // DarkSalmon
    '#483D8B', // DarkSlateBlue
    '#2F4F4F' // DarkSlateGray
];

export const highlightColors = [
    '#FFFFFF', // White
    '#FFFF00', // Yellow
    '#00FF00', // Lime
    '#00FFFF', // Aqua
    '#FF00FF', // Fuchsia
    '#FF9900', // Orange
    '#00FF99', // Spring Green
    '#99FF00', // Yellow Green
    '#FF99CC', // Pink
    '#99CCFF', // Light Blue
    '#FF99FF', // Light Purple
    '#FFCC99', // Peach
    '#99FFCC', // Mint
    '#FFFF99', // Light Yellow
    '#99FFFF', // Light Cyan
    '#FFE4E1' // Misty Rose
];